/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnKeySkills
 */
export interface SourcingSearchFilterOnKeySkills {
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchFilterOnKeySkills
     */
    skills: Array<string>;
}

/**
 * Check if a given object implements the SourcingSearchFilterOnKeySkills interface.
 */
export function instanceOfSourcingSearchFilterOnKeySkills(value: object): value is SourcingSearchFilterOnKeySkills {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnKeySkillsFromJSON(json: any): SourcingSearchFilterOnKeySkills {
    return SourcingSearchFilterOnKeySkillsFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnKeySkillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnKeySkills {
    if (json == null) {
        return json;
    }
    return {
        
        'skills': json['skills'],
    };
}

export function SourcingSearchFilterOnKeySkillsToJSON(value?: SourcingSearchFilterOnKeySkills | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'skills': value['skills'],
    };
}

